export const APP_CONFIG = {
  appName: 'Elements',
  frontend: 'https://elements.matthey.com',
  apiHash: 'https://elements.matthey.com/api/1.0',
  api: '/api/2.0',
  trustModel: false,
  commitSHA: '8931abe',
  authHeaders: {
    xServiceProvider: 'elements-prod-frontend',
    'tenant-id': '2a29f098-fc74-4740-b66d-6898c42eb476',
    'consumer-id': '3ee3fd33-b8ce-473a-b44f-7aa80a943c6d',
  },
  provider: 'elements-prod-frontend',
  gtm: 'GTM-PGLWNMC',
  colors: {
    primary: '#c400f5',
    secondary: '#04fae1',
    elementBackgroundColour: '#181818',
actionBg: '#c400f5',
actionText: '#ffffff',
  },
  benefitPIDS: [79, 39, 68, 12, 138, 109],
  multilingual: false,
  demoMode: false,
  contactEnabled: false,
  benefitCategories: false,
  articleThumbnails: true,
  showNotifications: true,
  showSearch: true,
  showHeroImages: true,
  showPosts: true,
  blurredBackground: true,
  isDarkModeEnabled: true,
  isDarkMode: true,
  chatEnabled: false,
  showDarkModeSwitch: false,
  copyright: '<small>&copy; ' + new Date().getFullYear() +
      ' Gallagher | All Rights Reserved.' + '<br />Powered by Core.' + '</small>',
  navigation: {
    navType: 'top',
    collapsibleSidenav: false,
    headerStyle: 'solid',
    stickyNav: true,
    navbarBrandWidth: '192px',
    fullWidthNavigation: false,
    categoryNav: true
  },
  pwa: {
    enabled: false,
    notifications: false,
  },
  cookiePolicy: 'a57e434e',
  coreLinkify: true,
  enableSSR: false,
  imagery: {
    logo: 'https://storage.googleapis.com/archipelago-assets/JM/jmeps-elements-logo.svg',
    logoInverted: 'https://storage.googleapis.com/archipelago-assets/JM/jmeps-elements-logo.svg',
    logoTransparent: 'https://storage.googleapis.com/archipelago-assets/JM/jmeps-elements-logo.svg',
  },
  auth: {
    routes: ['login', 'authenticate'],
    displayLoggedInUser: true,
    loggedInUserMetadata: ['firstName', 'lastName'],
  },
};

